import React, { useState } from "react";
import Index from "../../../..";
import PagesIndex from "../../../../PageIndex";
import DataService from "../../../../../config/DataService";
import { Api } from "../../../../../config/Api";
import { jobTypeAddSchema } from "../../../../../validation/FormikSchema";
import Loader from "../../../../../common/loader/Loader";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
};
const AddJobTypeModal = (props) => {
  const {
    addJobTypeopen,
    handleAddJobTypeClose,
    getJobTypeList,
    editJobTypeData,
  } = props;
  const [isLoading, setIsLoading] = useState(false);
  // validation regex
  const NUMERIC_REGEX_ONLY = /^[a-zA-Z ]+$/;
  const initialValues = {
    jobType: editJobTypeData ? editJobTypeData?.jobType : "",
  };

  const handleAddJobTypeForm = async (values) => {
    setIsLoading(true)
    const urlEncoded = new URLSearchParams();
    if (editJobTypeData) {
      urlEncoded.append("id", editJobTypeData?._id);
    }
    urlEncoded.append("jobType", values?.jobType);
    try {
      const response = await DataService.post(
        Api.Admin.ADD_EDIT_JOBTYPE,
        urlEncoded
      );
      if (response?.data?.status === 200 || 201) {
        PagesIndex.toast.success(response?.data?.message, { toastId: "customId" });
        handleAddJobTypeClose();
        getJobTypeList();
        setTimeout(() => {
          setIsLoading(false);
        }, 2000)
      }
    } catch (error) {
      PagesIndex.toast.error(error?.response?.data?.message, { toastId: "customId" });
      setIsLoading(false);
    }
  };
  return (
    <>
      <Index.Modal
        open={addJobTypeopen}
        onClose={handleAddJobTypeClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="modal"
      >
        <PagesIndex.Formik
          validationSchema={jobTypeAddSchema}
          initialValues={initialValues}
          onSubmit={handleAddJobTypeForm}
        >
          {({
            values,
            errors,
            handleChange,
            handleBlur,
            touched,
            handleSubmit,
            setFieldTouched,
            handleFocus,
          }) => (
            <form onSubmit={handleSubmit}>
              {/* {console.log("error", errors)} */}
              {/* {console.log("values>>",values)} */}
              <Index.Box
                sx={style}
                className="add-user-modal-inner-main modal-inner"
              >
                <Index.Box className="modal-header">
                  <Index.Typography
                    id="modal-modal-title"
                    className="modal-title"
                    variant="h6"
                    component="h2"
                  >
                    {!editJobTypeData ? "Add New job type" : "Edit job type"}
                  </Index.Typography>
                  <img
                    src={PagesIndex.Svg.closeblack}
                    className="modal-close-icon"
                    onClick={handleAddJobTypeClose}
                    alt=""
                  />
                </Index.Box>

                <Index.Box className="modal-body">
                  <Index.Box className="admin-modal-hgt-scroll">
                    <Index.Box className="input-box modal-input-box">
                      <Index.FormHelperText className="form-lable">
                        Job type
                      </Index.FormHelperText>
                      <Index.Box className="form-group">
                        <Index.TextField
                          fullWidth
                          id="fullWidth"
                          className="form-control"
                          placeholder="Please enter job type"
                          name="jobType"
                          value={values.jobType}
                          // onChange={han
                          onChange={(e) => {
                            handleChange(e);
                            setFieldTouched("jobType", true);
                          }}
                          inputProps={{maxLength: 30}}
                          // onBlur={handleBlur}
                          focused={false}
                          error={errors.jobType && touched.jobType ? true : false}
                          helperText={
                            errors.jobType && touched.jobType
                              ? errors.jobType
                              : null
                          }
                          // onKeyDown={(e) => {
                          //   if (e.key === " " && e.target.value.trim() === "") {
                          //     e.preventDefault();
                          //   }
                          //   if (!NUMERIC_REGEX_ONLY.test(e.key)) {
                          //     e.preventDefault();
                          //   }
                          // }}

                          onKeyDown={(e) => {
                            if (e.key === " " && e.target.value.trim() === "") {
                              e.preventDefault(); // Prevent space as the first character
                            } else if (e.target.value.trim().split(" ").length >= 2 && e.key === " ") {
                              e.preventDefault(); // Prevent adding additional spaces between words
                            } else if (e.key === " " && e.target.value.endsWith(" ")) {
                              e.preventDefault(); // Prevent additional spaces at the end
                            }
                            if (!NUMERIC_REGEX_ONLY.test(e.key)) {
                              e.preventDefault(); // Prevent non-numeric characters
                            }
                          }}
                          onPaste={(e) => e.preventDefault()} // Prevent paste
                        />
                      </Index.Box>
                    </Index.Box>
                  </Index.Box>
                </Index.Box>


                <Index.Box className="modal-footer">
                  <Index.Box className="modal-footer-btn-flex">
                    <Index.PrimaryButton
                      btnLabel={!editJobTypeData ? "Add" : "update"}
                      className="btn-primary bg-approve"
                      type="submit"
                      disabled={isLoading}

                    >
                      {isLoading ? <Loader /> : 'Click me'}
                    </Index.PrimaryButton>

                    <Index.PrimaryButton
                      btnLabel="cancel"
                      className="btn-primary bg-suspend"
                      onClick={() => handleAddJobTypeClose()}
                    />
                  </Index.Box>
                </Index.Box>
              </Index.Box>
            </form>
          )}
        </PagesIndex.Formik>
      </Index.Modal>
    </>
  );
};

export default AddJobTypeModal;
